import { articleCards } from '@/mocks/article-cards';

export default function ArticleCardsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            SEO Guides
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            Sugargoo Spreadsheet Resources &amp; Guides
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Expert articles to help you master Sugargoo Spreadsheets, save on shipping, and discover the best products.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleCards.map((card) => (
            <a
              key={card.title}
              href={card.link}
              className="group block rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-800 text-xs font-medium">
                  {card.badge}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.excerpt}
                </p>
                <div className="flex items-center gap-1.5 mt-3 text-primary-600 text-sm font-medium">
                  Read Article
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}